import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    endereco: '',
    nomeEmpresa: '',
    plano: '',
    statusCadastro: 60,
    categories: [],
    allowedCategoriesForScheduled: [],
    payments: [],
    families: []
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/detalheCadastro/index.js